import { Inject } from '@odinjs/odin';
import { ContextType, Value } from '@philips-internal/oswald-ui-core';

import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';

interface DataContext {
  get(key: string): Value;
  get<T = Value>(key: string): T;
  set(data: { [key: string]: Value }): void;
}

class BaseController {

  historyService = HistoryService;

  @Inject(ContextType.DATA)
  declare context: DataContext;

  getHistoryRouteParam<T>(param: string): T {
    return this.historyService.getCurrentRouteParams()[param] as T;
  }

}

export default BaseController;